// Ported from twifi-theme-html/src/scripts/helpers/content-tabs.js
function activateTab(tab) {
    const tablist = tab.closest('.content-tabs');
    const tabs = tablist.querySelectorAll('.content-tabs__tab');

    tabs.forEach((t) => {
        const selected = t === tab;

        t.classList.toggle('content-tabs__tab--active', selected);
        t.setAttribute('aria-selected', String(selected));
        t.setAttribute('tabindex', selected ? '0' : '-1');

        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
    });
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.content-tabs__tab').forEach((tab) => {
        tab.addEventListener('click', () => activateTab(tab));
    });

    document.querySelectorAll('.content-tabs').forEach((tablist) => {
        tablist.addEventListener('keydown', (event) => {
            const tabs = Array.from(tablist.querySelectorAll('.content-tabs__tab'));
            const index = tabs.indexOf(document.activeElement);

            if (index === -1) return;

            let nextIndex = null;
            if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = tabs.length - 1;

            if (nextIndex !== null) {
                event.preventDefault();
                tabs[nextIndex].focus();
                activateTab(tabs[nextIndex]);
            }
        });
    });
});
